import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Board from '../../../components/Board';
import BoardName from '../../../components/BoardName';
import CreateNode from '../../../components/CreateNode';
import CreateConnection from '../../../components/CreateConnection';
import DeleteNode from '../../../components/DeleteNode';
import Disconnect from '../../../components/Disconnect';
import ManageEvidence from '../../../components/ManageEvidence';
import Mint from '../../../components/Mint';
import ModifyNode from '../../../components/ModifyNode';
import NewBoard from '../../../components/NewBoard';
import NodeMenu from '../../../components/NodeMenu';
import Toolbar from '../../../components/Toolbar';
import Walkthrough from '../../../components/Walkthrough';
import { RESIZE } from '../../../redux/actions/board';
import './style.css';
import CloseWarning from '../../../components/CloseWarning';

const Home = () => {

    const dispatch = useDispatch();

    /**
     * @name dispatchResize
     * @function
     * @description Alerts the app to change the magnification sizes
     */
    const dispatchResize = useCallback(() => {
        dispatch({ type: RESIZE });
    }, [ dispatch ])

    // let the app know what we're dealing with
    useEffect(() => {
        dispatch({ type: RESIZE });
        window.addEventListener( 'resize', dispatchResize, true );
        return () => {
            window.removeEventListener( 'resize', dispatchResize, true );
        }
    }, [ dispatch, dispatchResize ]);

    return (
        <>
            <BoardName />
            <Board />
            <Toolbar />
            <NodeMenu />
            <CreateNode />
            <CreateConnection />
            <DeleteNode />
            <Disconnect />
            <ModifyNode />
            <ManageEvidence />
            <NewBoard />
            <CloseWarning />
            <Walkthrough />
            <Mint />
        </>
    )

}

export default Home